import { render } from "./TrialCompleteOwner.vue?vue&type=template&id=0f242170"
import script from "./TrialCompleteOwner.vue?vue&type=script&lang=js"
export * from "./TrialCompleteOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__